import { ITheme } from "../types";

export const themeData: ITheme[] = [
  {
    id: "lavender",
    title: "Lavender",
    primaryPlaintiff: "darkPurple",
    secondaryPlaintiff: "lightPurple",
    primaryDefendant: "darkPetrol",
    secondaryDefendant: "lightPetrol",
  },
  {
    id: "adventure",
    title: "Adventure",
    primaryPlaintiff: "darkOrange",
    secondaryPlaintiff: "lightOrange",
    primaryDefendant: "darkGreen",
    secondaryDefendant: "softGreen",
  },
  {
    id: "dreams",
    title: "Dreams",
    primaryPlaintiff: "darkPurple",
    secondaryPlaintiff: "lightPurple",
    primaryDefendant: "yellow",
    secondaryDefendant: "lightYellow",
  },
  {
    id: "forest",
    title: "Forest",
    primaryPlaintiff: "darkBlue",
    secondaryPlaintiff: "lightBlue",
    primaryDefendant: "leafGreen",
    secondaryDefendant: "lightLeafGreen",
  },
];
